import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Banner extends PureComponent {

    static propTypes = {
        image: PropTypes.string
    }

    render() {
        const { image } = this.props;

        return (
            <div style={{ marginBottom: '35px' }}>
                <img src={image} alt="" />
            </div>
        );
    }
}

export default Banner;
